import React from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import SelectConnector from '../shared/connectors/select-connector';
const SelectConnectorContainer = () => {
    const { search } = useLocation();
    const history = useHistory();
    return React.createElement(SelectConnector, { onSelectConnector: () => history.push({ pathname: '/buy/buy', search }), isBannerHidden: true });
};
export default SelectConnectorContainer;
